module.exports = __webpack_public_path__ + "static/media/Highland Ave San Carlos, CA11.fe23ba96.jpg";